import React from 'react'

const Loader = () => {
    return (
        <div className="baseocom-flex baseocom-my-8 baseocom-items-center baseocom-justify-center baseocom-w-full">
            <div className="baseocom-spinner"></div>
        </div>
    )
}

export default Loader
